export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10753.c85d7034.jpg";